export const APP_WEBVIEW_USER_AGENT = "ForgatherWebview";

// TODO(#155): 플레이스토어 심사 등록 완료 후 실제 스토어 URL로 교체
export const APP_STORE_URL =
  "https://apps.apple.com/kr/app/%ED%8F%AC%EA%B2%8C%EB%8D%94-forgather/id6795543031?l=en-GB";
export const PLAY_STORE_URL = "";
